interface IntroContentProp {
  children: JSX.Element;
}

const IntroContent: React.FC<IntroContentProp> = ({ children }) => (
  <div className="intro__content">{children}</div>
);

export default IntroContent;
